//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/no-cycle */
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref, onMounted } from '@vue/composition-api'
import { required, emailValidator } from '@core/utils/validation'
import themeConfig from '@themeConfig'
import { useUtils } from '@core/libs/i18n'
import { useRouter } from '@core/utils'
import useCryptoJs from '@core/utils/useCryptoJs'
import useLogData from '@core/utils/useLogData'
import { sendCodeSMSUser, sendConfirmationEmailUser } from '@api'

export default {
  setup() {
    const { t } = useUtils()
    const { router } = useRouter()
    const { encrypt } = useCryptoJs()
    const { logData, currentLogData, updateLogData } = useLogData()

    const form = ref(null)
    const loginData = ref({})

    const onYesNotAction = async response => {
      loginData.value.responseIsThisYou = response
      updateLogData(loginData.value)

      let respSend = null
      let info = null
      let encryptInfo = null
      if (loginData.value.typeIsThisYou === 'PHONE_NUMBER') {
        info = {
          phone_number: loginData.value.register.fullPhone,
        }
        encryptInfo = encrypt(info)
        respSend = await sendCodeSMSUser(encryptInfo)
      } else {
        info = {
          email: loginData.value.register.email,
        }
        encryptInfo = encrypt(info)
        respSend = await sendConfirmationEmailUser(encryptInfo)
      }
      if (respSend.ok) router.push({ name: 'auth-confirmation-code' })
    }

    onMounted(async () => {
      Object.assign(logData.value, currentLogData.value)
      logData.value.loginRoute = 'LOGIN_PAGE'
      loginData.value = logData.value
    })

    return {
      form,
      loginData,

      // themeConfig
      appLogo: themeConfig.app.logo,
      appLogoTitle: themeConfig.app.logoTitle,

      onYesNotAction,

      t,

      validators: {
        required,
        emailValidator,
      },

      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
